import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { ContractLeavingJobComponent } from '../contract-leaving-job/contract-leaving-job.component';

@Component({
  selector: 'app-contract-detail',
  templateUrl: './contract-detail.component.html',
  styleUrls: ['./contract-detail.component.css']
})
export class ContractDetailComponent implements OnInit {
  now = new Date();
  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ContractLeavingJobComponent>
  ) { }

  ngOnInit() {
  }
  setLeavingJobDate() {
    this.dialog
      .open(ContractLeavingJobComponent, {
        data: this.data,
        width: '300px'
      }).afterClosed().subscribe(() => {
        this.dialogRef.close();
      });
  }
  onNoClick() {
    this.dialogRef.close();
  }
  getParsDate(date: any): number {
    if (typeof (date) === 'string')
      return Date.parse(date);
    else if (date instanceof Date)
      return new Date(date).getTime()
  }
}
